<template>
  <div class="icons-call bg-gray-3 p-100">
    <div class="container">
      <div class="row align-items-center justify-content-around">
        <a class="link-black" href="http://localhost:8080/fazer-cotacao">
          <BasicService
            :title="'Cotação'"
            :icon="'fas fa-clipboard-list icon'"
            :description="'Inicie agora mesmo sua cotação.'"
            :destiny="'fazer-cotacao'"
            :buttonTitle="'Iniciar'"
          />
        </a>

        <a
          class="link-black"
          href="https://construp.com.br/area-restrita/cadastro"
        >
          <BasicService
            :title="'Empresa'"
            :icon="'fas fa-city icon'"
            :description="'Inclua sua Empresa em nossos processos de cotações. Inúmeras vantagens, venha conhecer!'"
            :destiny="'cadastro'"
            :buttonTitle="'Fazer Cadastro'"
          />
        </a>

        <a
          class="link-black"
          href="http://localhost:8080/guia-profissionais/geral"
        >
          <BasicService
            :title="'Serviços'"
            :icon="'fas fa-user-cog icon'"
            :description="'Encontre os serviços de profissionais da construção.'"
            :destiny="'guia-profissionais-geral'"
            :buttonTitle="'Encontrar'"
          />
        </a>
        <!-- <BasicService
            :title="'Afiliado'"
            :icon="'fas fa-edit icon'"
            :description="'Seja um afiliado da Constr Up e fature ainda mais!'"
            :destiny="'cadastro'"
            :buttonTitle="'Afiliar-se'" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import BasicService from './Menu/BasicService.vue';

export default {
  components: {
    BasicService,
  },
};
</script>

<style scoped>
.icon {
  font-size: 52px;
  padding: 4px;
}
.link-black {
  color: black;
}
.link-black:hover {
  color: black;
  text-decoration: none;
}

@import '../custom/css/sobre.css';
</style>
